<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
        <div class="tabContent">
        <div class="tabElement contrat active" @click="changeTab('contrat')">
          <span class="material-icons-sharp"> post_add </span>Contrat
        </div>
        <div class="tabElement bl" @click="changeTab('bl')">
          <span class="material-icons-sharp"> grid_view </span> Bl
        </div>
        <div
          class="tabElement conteneurWait"
          @click="changeTab('conteneurWait')"
        >
          <span class="material-icons-sharp"> cloud_queue </span>Conteneur en
          attente d'envoi en stock
        </div>
        <div class="tabElement conteneur" @click="changeTab('conteneur')">
          <span class="material-icons-sharp"> cloud_done </span>Conteneur envoyé
          en stock
        </div>
      </div>
      </div>


      <div id="contratTab" class="tabElementContent active">
        <div @click="addNewContrat" class="buttonAdd">
          <span> Ajouter un contrat</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in contratData"
                :key="item._id"
              >
                <td>
                  <div class="nameContentButton">
                    <div
                      @click="addNewContratDetails(item)"
                      class="buttonAddSecond"
                    >
                      <span> Gestion des factures</span>
                    </div>
                  </div>
                </td>
                <td @click="editeContratRow(item)">{{ item.number }}</td>
                <td @click="editeContratRow(item)">
                  {{ item.supplier ? item.supplier.fullName : "" }}
                </td>
                <td @click="editeContratRow(item)">
                  {{ item.supplier ? item.supplier.phones.join("/") : "" }}
                </td>
                <td @click="editeContratRow(item)">
                  {{ item.implementationDate }}
                </td>
                <td @click="editeContratRow(item)">
                  {{ raccourcirTexte(item.observation) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="conteneurTab" class="tabElementContent">
        <!-- <div @click="addNewBl" class="buttonAdd">
          <span> Ajouter un Bl</span>
        </div> -->
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeaderConteneur" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                @click="editeConteneurRow(item)"
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in contenuerAllData"
                :key="item._id"
              >
                <td @click="editeConteneurRow(item)">{{ item.name }}</td>
                <td @click="editeConteneurRow(item)">
                  {{ item.containType ? item.containType.name : "" }}
                </td>
                <td @click="editeConteneurRow(item)">
                  {{ item.contractDetail ? item.contractDetail.number : "" }}
                </td>
                <td @click="editeConteneurRow(item)">
                  {{ item.bl ? item.bl.number : "" }}
                </td>
                <td @click="editeConteneurRow(item)">
                  {{ item.product ? item.product.name : "" }}
                </td>

                <td @click="editeConteneurRow(item)">
                  {{ item.store ? item.store.name : "" }}
                </td>
                <td @click="editeConteneurRow(item)">
                  {{ item.outDate }}
                </td>
                <td @click="editeConteneurRow(item)">{{ item.observation }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="conteneurWaitTab" class="tabElementContent">
        <div class="flex">
          <div
            disabled
            @click="isSelecteds.length > 0 ? sendToStock() : ''"
            :class="isSelecteds.length > 0 ? 'buttonAdd' : 'buttonDisabled'"
          >
            <span>
              {{
                isSelecteds.length > 0
                  ? "Envoyer en magasin"
                  : "Sélectionnez au moins un élément"
              }}</span
            >
          </div>

          <div
            @click="addNewConteneur()"
            class="buttonAdd"
            v-if="isSelecteds.length == 0"
          >
            <span> {{ "Ajouter un conteneur" }}</span>
          </div>
          <div v-else @click="deleeContainerSelect()" class="buttonDelete">
            <span> {{ "Supprimer les conteneurs sélectionnés" }}</span>
          </div>
        </div>

        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeaderConteneurNone" :key="item">
                  {{ item }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in contenuerAllData"
                :key="item._id"
              >
                <td @click="makeSelect(item)">
                  <span
                    v-if="item.isSelected == true && isSelecteds.length > 0"
                    style="color: #149162"
                    class="material-icons-sharp"
                  >
                    check_circle
                  </span>
                  <span
                    v-else
                    style="color: #ba4f4f"
                    class="material-icons-sharp"
                  >
                    radio_button_unchecked
                  </span>
                </td>
                <td @click="editeConteneurRow(item)">{{ item.name }}</td>
                <td @click="editeConteneurRow(item)">
                  {{ item.containType ? item.containType.name : "" }}
                </td>
                <td @click="editeConteneurRow(item)">
                  {{ item.contractDetail ? item.contractDetail.number : "" }}
                </td>
                <td @click="editeConteneurRow(item)">
                  {{ item.bl ? item.bl.number : "" }}
                </td>
                <td @click="editeConteneurRow(item)">
                  {{ item.product ? item.product.name : "" }}
                </td>

                <td @click="editeConteneurRow(item)">{{ item.observation }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="blTab" class="tabElementContent">
        <div @click="addNewBl" class="buttonAdd">
          <span> Ajouter un Bl</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeaderBl" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in blData"
                :key="item._id"
              >
                <td @click="addNewTaxForBlDetails(item)">
                  <div class="nameContentButton">
                    <div
                      @click="addNewTaxForBlDetails(item)"
                      class="buttonAddSecond"
                    >
                      <span> Dépense</span>
                    </div>
                  </div>
                </td>
                <td @click="editeBlRow(item)">
                  {{ item.contractDetail ? item.contractDetail.number : "" }}
                </td>
                <td @click="editeBlRow(item)">{{ item.number }}</td>
                <td @click="editeBlRow(item)">{{ item.totalContainer }}</td>
                <td @click="editeBlRow(item)">{{ item.loadingPort }}</td>
                <!-- <td  @click="editeBlRow(item)">{{ item.shipName }}</td>
                <td  @click="editeBlRow(item)">{{ item.etdPol }}</td> -->
                <td @click="editeBlRow(item)">{{ item.eta }}</td>
                <td @click="editeBlRow(item)">
                  {{ item.transitaire ? item.transitaire.fullName : "" }}
                </td>
                <td @click="editeBlRow(item)">{{ item.transitaireAmount }}</td>
                <td @click="editeBlRow(item)">{{ item.outTotalAmount }}</td>
                <td @click="editeBlRow(item)">
                  {{ item.blCoastPrice ? item.blCoastPrice.amount : "--" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "approvisionnementView",
  components: {},
  data: () => ({
    tableHeader: [
      "",
      "Numéro de contrat",
      "Fournisseur",
      "Contact Fournisseur",
      "Date de mise en place",
      "Observation",
    ],
    isSelecteds: [],
    isSelectedAll: false,
    tableHeaderBl: [
      "",
      "Facture",
      "Numéro BL",
      "Nbr de conteneur",
      "Port de chargement",
      "ETA",
      "Transitaire",
      "Montant Transitaire",
      "Montant total sortie",
      "Prix de revien total",
    ],
    tableHeaderConteneur: [
      "Numéro conteneur",
      "Type de conteneur",
      "Numéro Facture",
      "Numéro BL",
      "Désignation",

      "Magasin",
      "Date d'envoie",
      "Observation",
    ],
    tableHeaderConteneurNone: [
      "",
      "Numéro conteneur",
      "Type de conteneur",
      "Numéro Facture",
      "Numéro BL",
      "Désignation",

      "Observation",
    ],
  }),
  watch: {
    contenuerAllData() {
      this.isSelecteds = [];
    },
  },
  computed: {
    ...mapGetters([
      "contratData",
      "blData",
      "conteneurData",
      "contenuerAllData",
      "storeData",
      "taxData",
    ]),
  },
  async mounted() {
     this.$emit("show", true);
    await this.getContrat({});
     this.$emit("show", false);
  },
  methods: {
    ...mapActions([
      "getContrat",
      "getContratDetails",
      "getSupplier",
      "getContratDetails",
      "getBl",
      "getConteneur",
      "getConteneurAll",
      "getTransitaire",
      "getStore",
      "getTaxOfContainer",
      "getTaxOtherOfContainer",
      "getTransitContainer",
      "getProduct",
    ]),
    raccourcirTexte(texte) {
      return texte;
    },
    async sendToStock() {
      this.$emit("show", true);
      await this.getStore({});
      const value = {
        modalType: "sendToStock",
        isSelecteds: this.isSelecteds,
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "sendToStock",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async deleeContainerSelect() {
      this.$emit("show", true);
      // await this.getStore({});
      const value = {
        modalType: "deleteContainer",
        isSelecteds: this.isSelecteds,
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "deleteContainer",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async addNewContrat() {
      this.$emit("show", true);
      await this.getSupplier({});
      const value = {
        modalType: "contrat",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "contrat",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async addNewBl() {
      this.$emit("show", true);
      await this.getContratDetails({});
      await this.getConteneur();
      await this.getTransitaire();
      // await this.getTaxOfContainer({ conteneur: item._id });
      const value = {
        modalType: "bl",
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "bl",
        size: 300,
        value: value,
      });
      this.$emit("show", false);
    },
    async editeContratRow(item) {
      this.$emit("show", true);
      await this.getSupplier({});
      if (!item.isSelected) {
        for (let i = 0; i < this.contratData.length; i++) {
          this.contratData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.contratData);
        const value = {
          _id: item._id,
          modalType: "contrat",
          number: item.number,
          supplier: item.supplier ? item.supplier.fullName : "",
          observation: item.observation,
          implementationDate: item.implementationDate,
        };
        this.$emit("editeRowForDash", {
          name: "contrat",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeBlRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.blData.length; i++) {
          this.blData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.blData);
        await this.getContratDetails({});
        await this.getContrat({});
        await this.getTransitaire();
        const value = {
          _id: item._id,
          modalType: "bl",
          observation: item.observation,
          number: item.number,
          shipName: item.shipName,
          lineName: item.lineName,
          loadingPort: item.loadingPort,
          lastPosition: item.lastPosition,
          etdPol: item.etdPol,
          destination: item.destination,
          eta: item.eta,
          contractExecutionDelay: item.contractExecutionDelay
            ? item.contractExecutionDelay
            : 0,
          unitCoastPrice: item.unitCoastPrice ? item.unitCoastPrice.amount : 0,
          transitaireAmount: item.transitaireAmount,
          contractDetail: item.contractDetail ? item.contractDetail.number : "",
          transitaire: item.transitaire ? item.transitaire.fullName : "",
        };
        this.$emit("editeRowForDash", {
          name: "bl",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async addNewConteneur() {
      this.$emit("show", true);

      const value = {
        modalType: "addConteneur",
      };

      await this.getContratDetails({});
      await this.getBl({});
      await this.getConteneur();
      this.$emit("editeRowForDash", {
        name: "addConteneur",
        size: 300,
        value: value,
      });

      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeConteneurRow(item) {
      this.$emit("show", true);
      if (!item.isSelected) {
        for (let i = 0; i < this.contenuerAllData.length; i++) {
          this.contenuerAllData[i].isSelected = false;
        }
        item.isSelected = true;
        // alert(item.eta)
        const value = {
          _id: item._id,
          modalType: "conteneurPrincipaleAll",
          observation: item.observation,
          containType: item.containType ? item.containType.name : "",
          store: item.store ? item.store.name : "",
          contractDetail: item.contractDetail ? item.contractDetail.number : "",
          name: item.name,
          bl: item.bl ? item.bl.number : "",
          product: item.product ? item.product.name : "",
          outDate: item.outDate,
          tonsQuantity: item.tonsQuantity,
          quantity: item.quantity,
          etdPol: item.etdPol ? item.etdPol : item.bl ? item.bl.etdPol : "",
          eta: item.eta ? item.eta : item.bl ? item.bl.eta : "",
          shipName: item.shipName
            ? item.shipName
            : item.bl
            ? item.bl.shipName
            : "",
          transitaire: item.transitaire ? item.transitaire.fullName : "",
          transitaireAmount: item.transitaireAmount
            ? item.transitaireAmount
            : 0,
          amount: item.amount ? item.amount : 0,
        };

        await this.getProduct({});
        await this.getContratDetails({});
        await this.getBl({});
        await this.getConteneur();
        this.$emit("editeRowForDash", {
          name: "conteneurPrincipaleAll",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async addNewContratDetails(item) {
      this.$emit("show", true);

      if (!item.isSelected) {
        for (let i = 0; i < this.contratData.length; i++) {
          this.contratData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.contratData);
        await this.getSupplier({});
        const value = {
          _id: item._id,
          modalType: "commande",
          number: item.number,
          supplier: item.supplier ? item.supplier.fullName : "",
          observation: item.observation,
        };
        await this.getContratDetails({ contract: item._id });
        this.$emit("editeRowForDash", {
          name: "commande",
          size: 1000,
          value: value,
        });
        // alert(JSON.stringify(value))
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async addNewTaxForBlDetails(item) {
      this.$emit("show", true);

      if (!item.isSelected) {
        for (let i = 0; i < this.contratData.length; i++) {
          this.contratData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.contratData);
        await this.getSupplier({});
        const value = {
          _id: item._id,
          modalType: "taxForBl",
          number: item.number,
          totalContainer: item.totalContainer,
          observation: item.observation,
        };
        await this.getTransitContainer({ bl: item._id });
        await this.getTaxOfContainer({ bl: item._id });
        await this.getTaxOtherOfContainer({ bl: item._id });
        this.$emit("editeRowForDash", {
          name: "taxForBl",
          size: 1000,
          value: value,
        });
        // alert(JSON.stringify(value))
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show", false);
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    //     makeSelectAll() {

    //   if (!this.isSelectedAll) {
    //     this.isSelectedAll = true;

    //     this.contenuerAllData.forEach((resourceItem) => {
    //       resourceItem.isSelected = true;
    //       this.isSelected.push(resourceItem._id);
    //     });

    //   } else {
    //     this.isSelectedAll = false;

    //     this.contenuerAllData.forEach((resourceItem) => {

    //       const index = this.isSelected.indexOf(resourceItem._id);
    //       resourceItem.isSelected = false;
    //       if (index !== -1) {
    //         this.isSelected.splice(index, 1);
    //       }
    //     });
    //   }
    // },
    makeSelect(item) {
      if (!item.isSelected) {
        item.isSelected = true; // Met item.isSelected à true

        this.isSelecteds.push(item._id);
      } else {
        item.isSelected = false;

        const index = this.isSelecteds.indexOf(item._id);
        if (index !== -1) {
          this.isSelecteds.splice(index, 1);
        }
      }
      // alert(JSON.stringify(this.selectedItemsIds));
    },
    async changeTab(tabName) {
      this.$emit("show", true);
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getContrat({});
      } else if (tabName === "bl") {
        await this.getBl({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
      this.$emit("show", false);
    },
  },
};
</script>
